<template>
  <div>
    <v-layout ml-3 row>
      <v-row class="container cyan lighten-5 mb-5">
            <draggable
              class="draggable-outer-container"
              v-model="presets">
              <transition-group
               class="draggable-container">
                <div
                  v-for="preset in presets"
                  :key="preset.text">
                  <div
                    v-if="preset.status"
                    :class="{ 'box-item mx-1 my-1' : true, [preset.color] : true }"
                      >
                      <span>
                        {{ preset.text }}
                      </span>
                      <v-icon @click="changeStatus(preset, false)" class="close-icon">mdi-close</v-icon>
                  </div>
                </div>
              </transition-group>
            </draggable>
      </v-row>
      <v-row>
        <v-tooltip top>
          <template v-slot:activator="{ on }" >
            <v-btn
              @click="resetAllpresets"
              v-on="on"
              rounded
              small
              outlined
              :disabled="!defaultPresetsBtn"
              class="theme-main-color mb-5">
                Set default presets
              <v-icon small class="ml-2">mdi-backup-restore</v-icon>
            </v-btn>
          </template>
          <span>Revert to showcase default presets that were initially set to be showcased</span>
        </v-tooltip>
      </v-row>
      <v-row v-if="unChoosedPresets.length" class="container grey lighten-4">
        <div
          @click="changeStatus(preset, true)"
          :key="preset.text"
          v-for="preset in unChoosedPresets"
          class="box-item unchoosed-box mx-1 my-1 secondary lighten-4">
           {{ preset.text }}
        </div>
      </v-row>
    </v-layout>
  </div>
</template>

<script>
import { presets } from '@/utils/presets/index'
import { mapMutations, mapState } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'New-combo-showcase-box',
  components: {
    draggable
  },
  data: () => ({
    colors: ['green', 'teal', 'indigo', 'cyan', 'teal', 'orange', 'secondary', 'blue'],
    presets: [],
    boxIsMoving: false,
    version: 5,
    localPresetsUpdated: 1
  }),
  watch: {
    choosedPresets (val) {
      this.setPresetsToShowCase(val)
    },
    presets (presets) {
      this.updateReloadCashierCarousel()
      const saveNewPresets = []
      for (let preset in presets) {
        if (presets[preset].text) {
          saveNewPresets.push(presets[preset])
        }
      }
      localStorage.setItem(this.localStorageName, JSON.stringify(saveNewPresets))
      this.localPresetsUpdated++
    }
  },
  computed: {
    ...mapState({
      getAllPresets: ({ config }) => config.allPresets
    }),
    allAndLocalPresetsNames () {
      return this.localPresetsUpdated && JSON.parse(localStorage.getItem(this.localStorageName))
        .filter(val => val.status).map(el => el.text)
    },
    defaultPresetsBtn () {
      const { allAndLocalPresetsNames } = this
      const originalPresetsAsNames = []
      for (let i in this.getAllPresets) {
        if (this.getAllPresets[i].includeInShowcase) {
          originalPresetsAsNames.push(i)
        }
      }
      return allAndLocalPresetsNames.some(preset => !originalPresetsAsNames.includes(preset))
    },
    localStorageName () {
      // Update this.version to restore presetstoshowcase for all users
      return `presetsToShowcase${this.version}`
    },
    unChoosedPresets () {
      return this.presets.filter(val => !val.status)
    },
    choosedPresets () {
      return this.presets.filter(val => val.status)
    },
    allPresets () {
      const presetNames = [ ...Object.keys(this.getAllPresets) ]
      const allPresets = presetNames.map(val => {
        return {
          text: val,
          color: this.colors[Math.ceil(Math.random() * (this.colors.length - 1))],
          status: this.getAllPresets[val].includeInShowcase
        }
      })
      const sorted = allPresets.sort((a, b) => a.text.charCodeAt(0) - b.text.charCodeAt(0))
      return sorted
    }
  },
  methods: {
    ...mapMutations([
      'setPresetsToShowCase',
      'updateReloadCashierCarousel'
    ]),
    resetAllpresets () {
      this.presets = this.allPresets.map(preset => {
        preset.status = presets[preset.text].includeInShowcase || false
        return preset
      })
    },
    changeStatus (preset, newStatus) {
      this.presets = this.presets.map(val => {
        if (val.text === preset.text) {
          val.status = newStatus
          return val
        } else {
          return val
        }
      })
    }
  },
  mounted () {
    const clearOldLocalStoragePresets = localStorage && Object.keys(localStorage).length
    if (clearOldLocalStoragePresets) {
      Object.keys(localStorage).forEach(name => {
        if (name.includes('presetsToShowcase') && name !== this.localStorageName) {
          localStorage.removeItem(name)
        }
      })
    }
  },
  created () {
    const showcaseStorage = localStorage.getItem(this.localStorageName) && JSON.parse(localStorage.getItem(this.localStorageName))
    if (!showcaseStorage) {
      localStorage.setItem(this.localStorageName, JSON.stringify([]))
      this.presets = this.allPresets
      return
    }
    const allPresets = []
    for (let p in showcaseStorage) {
      const allPresetsNames = this.allPresets.map(val => val.text)
      if (allPresetsNames.includes(showcaseStorage[p].text)) {
        allPresets.push(showcaseStorage[p])
      }
    }
    const names = allPresets.map(val => val.text)
    this.allPresets.forEach(val => {
      if (!names.includes(val.text)) {
        allPresets.push(val)
      }
    })
    this.presets = allPresets.map(val => {
      val.color = this.colors[Math.ceil(Math.random() * (this.colors.length - 1))]
      return val
    })
  }
}
</script>

<style lang="scss" scoped>
.draggable-outer-container {
  position: relative;
  .draggable-container {
    display: flex;
    flex-wrap: wrap;
  }
}
.container {
  position: relative;
  box-shadow: 1px 1px 2px 2px lightgray;
  border-radius: 10px;
  .box-item {
    display: flex;
    justify-content: space-between;
    flex-direction: wrap;
    padding: 5px 10px;
    border-radius: 5px;
    color: #ffffff;
    width: 200px;
    &:hover {
      box-shadow: 1px 1px 1px 1px lightgray;
    }
    span {
      cursor:all-scroll!important;
    }
  }
  .close-icon {
    color: #ffffff;
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
  }
  .unchoosed-box {
    cursor: pointer;
  }
}
.v-application .ml-3 {
  margin-left: 0 !important;
}
.row {
  margin: 0;
}
</style>
